// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const weezing_galar: PokeData = {
  "id": 10167,
  "name": "weezing-galar",
  "height": 30,
  "weight": 160,
  "base_experience": 172,
  "types": [
    PokeType.POISON,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "toxic",
    "smokescreen",
    "haze",
    "self-destruct",
    "smog",
    "sludge",
    "poison-gas",
    "explosion",
    "sludge-bomb",
    "destiny-bond",
    "heat-wave",
    "memento",
    "aromatherapy",
    "assurance",
    "defog",
    "double-hit",
    "clear-smog",
    "belch",
    "misty-terrain",
    "fairy-wind",
    "aromatic-mist",
    "strange-steam"
  ],
  "moves": [
    "tackle",
    "poison-gas",
    "sludge-bomb",
    "aromatherapy",
    "misty-terrain",
    "venom-drench",
    "play-rough",
    "stun-spore",
    "moonlight",
    "sweet-kiss",
    "mist-terrain",
    "mortal-gas",
    "starfall"
  ],
  "evolution_chain": {
    "id": 49,
    "item": null,
    "species": [
      {
        "name": "koffing",
        "order": 121,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "weezing",
        "order": 122,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 109,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 139,
    "speed": 104,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
